import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import type { HeaderProps } from '../../../types/commands/index.tsx';
import { MODAL_HEADER_TEST_ID } from './constants.tsx';

export const Header = ({ children }: HeaderProps): React.JSX.Element => (
	<Box xcss={headerStyles} testId={MODAL_HEADER_TEST_ID}>
		{children}
	</Box>
);

const headerStyles = xcss({
	borderTopLeftRadius: 'inherit',
	borderTopRightRadius: 'inherit',
	padding: 'space.200',

	borderBottom: `solid 1px ${token('color.border')}`,
});
